import { render, staticRenderFns } from "./loadingBar.vue?vue&type=template&id=15af1290&scoped=true&"
import script from "./loadingBar.vue?vue&type=script&lang=ts&"
export * from "./loadingBar.vue?vue&type=script&lang=ts&"
import style0 from "./loadingBar.vue?vue&type=style&index=0&id=15af1290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af1290",
  null
  
)

component.options.__file = "loadingBar.vue"
export default component.exports